import axios from 'axios';

const apiUrl = process.env.BACKEND_ENDPOINT;

export interface Catalog {
  type: string;
  title: string;
  slug: string;
  description: string;
  tags: string[];
  isFree: boolean;
  isOnline: boolean;
  isDigital?: boolean;
  category: string;
  targets: string[];
  department: string;
  departmentSections: string[];
  categorySlug: string;
  highlighted: boolean;
  score: number;
  imageUrl: string;
  icon: string;
  link: string;
  resultTotal: number;
}

interface params {
  accessToken?: string;
  query?: string;
  category?: string[];
  departmentSlug?: string;
  from?: number;
  size?: number;
}

interface multiFieldParams {
  accessToken?: string;
  query: string;
  category?: string[];
  limit?: number;
  offset?: number;
}

export async function search({
  accessToken,
  query,
  category,
  departmentSlug,
  from,
  size,
}: params): Promise<Catalog[]> {
  const response = await axios.post(
    `${apiUrl}/v1/search`,
    {
      query,
      groups: ['CATALOG'],
      category,
      departmentSlug,
      from,
      size,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
}

export async function searchMultiFieldByQuery({
  accessToken,
  query,
  category,
  limit,
  offset,
}: multiFieldParams): Promise<Catalog[]> {
  const response = await axios.get(`${apiUrl}/v1/search/multi-field-by-query`, {
    params: {
      q: query,
      limit,
      offset,
      category,
    },
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return response.data;
}
